import request from '../utils/request'


export function index(params) {
  return request({
    url: '/owner-branch',
    method: 'get',
    params
  })
}

export function show(id) {
  return request({
    url: `/owner-branch/${id}`,
    method: 'get'
  })
}

export function store(data) {
  return request({
    url: '/owner-branch',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: `/owner-branch/${data.id}`,
    method: 'put',
    data
  })
}

export function destroy(id) {
  return request({
    url: `/owner-branch/${id}`,
    method: 'delete',
  })
}

export function destroyImage(id) {
  return request({
    url: `/owner-branch/delete-image/${id}`,
    method: 'delete',
  })
}
